export default {"src":"/_next/static/media/battery-mid.706144fe.svg","height":800,"width":800};